import { render, staticRenderFns } from "./TmsCarousel.vue?vue&type=template&id=272fdb5d&lang=pug&"
import script from "./TmsCarousel.vue?vue&type=script&lang=js&"
export * from "./TmsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports